import { render, staticRenderFns } from "./StaffCardContent.vue?vue&type=template&id=162eb112&"
import script from "./StaffCardContent.vue?vue&type=script&lang=ts&"
export * from "./StaffCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports